import { Tooltip } from "@mui/material";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { Tag } from "primereact/tag";
import notaIcon from '../../../../assets/icons/nota.png'
import React, { useEffect, useMemo, useRef, useState } from "react";
import '../Tablero.scss'
import ModalVerNotas from './ModalVerNotas';

import { Button } from "primereact/button";
import { getServicios } from "./integracionPanel";
const getStatusDesign = (status) => {
    switch (status) {
        case 1:
        case 2:
            return { tagColor: "#e03e3e", gradient: "linear-gradient(to right, #ff999933, #ff666611)" };
        case 3:
        case 4:
            return { tagColor: "#FF5733", gradient: "linear-gradient(to right, #FFB7A633, #FF998011)" };
        case 5:
        case 6:
            return { tagColor: "#FFC300", gradient: "linear-gradient(to right, #FFD70033, #FFC30011)" };
        case 7:
            return { tagColor: "#FF8C00", gradient: "linear-gradient(to right, #FFB84D33, #FFA50011)" };
        case 8:
            return { tagColor: "#C7E054", gradient: "linear-gradient(to right, #D9E37833, #C7E05411)" };
        case 9:
            return { tagColor: "#4CAF50", gradient: "linear-gradient(to right, #B3E0C133, #99E6B911)" };
        case 10:
        case 11:
            return { tagColor: "#3366ff", gradient: "linear-gradient(to right, #b3c6ff33, #80aaff11)" };
        default:
            return "";
    }
};
const todosLosEstatus = [
    { name: "NO CONFIRMADA, DEBIÓ INICIAR HACE X MIN", code: 1 },
    { name: "NO CONFIRMADA, INICIA EN", code: 2 },
    { name: "CONFIRMADA, DEBIÓ INICIAR HACE X MIN", code: 3 },
    { name: "CONFIRMADA, INICIA EN X MINUTOS", code: 4 },
    { name: "NO CONFIRMADA", code: 5 },
    { name: "CONFIRMADA", code: 6 },
    { name: "EN TRASLADO AL INICIO", code: 7 },
    { name: "EN CURSO, CON RETRASO DE X MIN", code: 8 },
    { name: "EN CURSO, EN TIEMPO", code: 9 },
    { name: "FINALIZADA EN TIEMPO", code: 10 },
    { name: "FINALIZADA CON Xmin RETRASO", code: 11 },
];
const ListaServiciosEnVivo = ({
    listaRutasPanelIzquierdo,
    setListaRutasPanelIzquierdo,
    setCentrarUnidad,
    zona,
    cliente,
    tipoServicio,
    confirmadoNoConfirmado,
    activeIndex,
    contadorPorMinuto,
    unidades,
    setUnidadSeleccionada,
    setServicios,
    servicios,
}) => {
    const [filtro, setFiltro] = useState("");
    const [estatusSeleccionados, setEstatusSeleccionados] = useState(todosLosEstatus);
    const [selectedItems, setSelectedItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [serviciosListos, setServiciosListos] = useState(false);
    const [showModalNotas, setShowModalNotas] = useState(false);
    const [notasSeleccionadas, setNotasSeleccionadas] = useState([]);
    const [servicioSeleccionado, setServicioSeleccionado] = useState('');
    const abortControllerRefServicios = useRef(null);
    const debounceTimerRef = useRef(null);

    const desmarcarTodo = () => {
        setSelectedItems([]);
        setListaRutasPanelIzquierdo([]);
    }
    useEffect(() => {
        if (activeIndex === 0) {

            // Cancela la petición anterior si existe
            if (abortControllerRefServicios.current) {
                abortControllerRefServicios.current.abort();
            }
            // Crea un nuevo AbortController para esta petición
            const controller = new AbortController();
            abortControllerRefServicios.current = controller;
            const data = {
                zona: zona,
                id_clientes: cliente,
                tipo_servicio: tipoServicio,
                confirmado_no_confirmado: confirmadoNoConfirmado
            }
            getServicios(
                (servs) => {
                    setServicios(servs);
                    setServiciosListos(true);
                },
                controller.signal, // Usa el signal del nuevo controller
                data
            );
        }

        // Cleanup: cancela la petición si cambia zona/contadorPorMinuto o se desmonta
        return () => {
            if (abortControllerRefServicios.current) {
                abortControllerRefServicios.current.abort();
            }
        };
    }, [zona, contadorPorMinuto, cliente, tipoServicio, confirmadoNoConfirmado]); // Agregar dependencias de filtros


    useEffect(() => {
        if (activeIndex === 0 && servicios.length > 0) {
            // Marcar los servicios que ya están en listaRutasPanelIzquierdo
            const itemsSeleccionados = servicios.filter(s =>
                listaRutasPanelIzquierdo.some(l => l.id === s.BITACORA)
            );
            setSelectedItems(itemsSeleccionados);
        }
    }, [activeIndex, servicios, listaRutasPanelIzquierdo]);

    const marcarTodo = () => {


        if (datosFiltrados.length === 0) {

            desmarcarTodo();
            return;
        }

        setSelectedItems(datosFiltrados);
        const nuevasRutas = datosFiltrados.map(item => ({
            chofer: item.OPERADOR_ID,
            code: item.SERVICIO_ID,
            confirmada: item.BITACORA_CONFIRMADA,
            id: item.BITACORA,
            name: item.SERVICIO,
            unidad: item.UNIDAD,
        }));
        setListaRutasPanelIzquierdo(nuevasRutas);
    };
    const datosFiltrados = useMemo(() => {


        if (!servicios || servicios.length === 0) {

            return [];
        }

        let resultados = servicios;

        if (filtro.trim()) {
            const query = filtro.toLowerCase();
            resultados = resultados.filter(
                (d) =>
                    d.SERVICIO?.toLowerCase().includes(query) ||
                    d.UNIDAD?.toLowerCase().includes(query) ||
                    d.ESTATUS?.toLowerCase().includes(query)
            );

        }

        if (estatusSeleccionados.length > 0) {
            const codigosSeleccionados = estatusSeleccionados.map((e) => e.code);

            // Log para ver algunos servicios de ejemplo y sus ESTATUS_ID
            if (servicios.length > 0) {
                servicios.slice(0, 3).forEach(s => {
                    console.log(`  - ${s.SERVICIO}: ESTATUS_ID=${s.ESTATUS_ID}, ESTATUS="${s.ESTATUS}"`);
                });
            }

            resultados = resultados.filter((d) => {
                const estatusValido = codigosSeleccionados.includes(Number(d.ESTATUS_ID));
                return estatusValido;
            });
        }
        return resultados;
    }, [filtro, estatusSeleccionados, servicios]);
    useEffect(() => {


        // Limpiar timer anterior
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }

        // Debounce para evitar actualizaciones muy frecuentes
        debounceTimerRef.current = setTimeout(() => {
            if (estatusSeleccionados.length === 0) {

                desmarcarTodo();
            } else {
                // SOLO actualizar las selecciones existentes, NO marcar todo automáticamente


                // Filtrar las selecciones actuales para que coincidan con los filtros
                const seleccionesValidas = selectedItems.filter(item =>
                    datosFiltrados.some(filtrado => filtrado.BITACORA === item.BITACORA)
                );

                if (seleccionesValidas.length !== selectedItems.length) {
                    setSelectedItems(seleccionesValidas);

                    const rutasValidas = seleccionesValidas.map(item => ({
                        chofer: item.OPERADOR_ID,
                        code: item.SERVICIO_ID,
                        confirmada: item.BITACORA_CONFIRMADA,
                        id: item.BITACORA,
                        name: item.SERVICIO,
                        unidad: item.UNIDAD,
                    }));

                    setListaRutasPanelIzquierdo(rutasValidas);
                }
            }
        }, 300);

        // Cleanup
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, [estatusSeleccionados, datosFiltrados]); // Remover serviciosListos de las dependencias

    // Efecto adicional para limpiar el mapa cuando el filtro de texto no produce resultados
    useEffect(() => {
        if (filtro.trim() && datosFiltrados.length === 0) {

            desmarcarTodo();
        }
    }, [filtro, datosFiltrados]);

    const toggleSelection = (item) => {
        const isSelected = selectedItems.some(
            (selectedItem) => selectedItem.BITACORA === item.BITACORA
        );
        if (isSelected) {
            setSelectedItems(
                selectedItems.filter(
                    (selectedItem) => selectedItem.BITACORA !== item.BITACORA
                ));
            setListaRutasPanelIzquierdo(
                listaRutasPanelIzquierdo.filter(
                    (selectedItem) => selectedItem.id !== item.BITACORA  // Nota: usar 'id' en lugar de 'BITACORA'
                ));
        } else {
            setSelectedItems([...selectedItems, item]);
            setListaRutasPanelIzquierdo([...listaRutasPanelIzquierdo, {
                chofer: item.OPERADOR_ID,
                code: item.SERVICIO_ID,
                confirmada: item.BITACORA_CONFIRMADA,
                id: item.BITACORA,
                name: item.SERVICIO,
                unidad: item.UNIDAD,
            }]);

        }
    };

    const handleMostrarNotas = (item, e) => {
        e.stopPropagation(); // Evitar que se active el click del item
        setNotasSeleccionadas(item.NOTAS || []);
        setServicioSeleccionado(item.SERVICIO);
        setShowModalNotas(true);
    };

    const itemTemplate = (item) => {
        if (!item) {
            return null;
        }

        const design = getStatusDesign(Number(item.ESTATUS_ID));
        const isSelected = selectedItems.some(
            (selectedItem) => selectedItem.BITACORA === item.BITACORA
        );

        // Estilos dinámicos para elementos seleccionados
        const itemStyle = {
            background: isSelected
                ? "linear-gradient(to right, #007ad933, #0056b311)"
                : design.gradient,
            border: isSelected ? "2px solid #007ad9" : "1px solid transparent",
            position: "relative"
        };

        const findCordsUnidad = (item) => {
            let coordenadas = { lat: 0, lng: 0 };
            const unidad = unidades.find(u => u.UNIDAD == item.UNIDAD);
            if (unidad) {
                setCentrarUnidad(unidad.coordenadas);
                coordenadas = unidad.coordenadas;
            }
            setUnidadSeleccionada({
                CHOFER: item.OPERADOR,
                ID_BITACORA: item.BITACORA,
                TIPO_UNIDAD: item.TIPO,
                RUTA: item.SERVICIO,
                TELEFONO: item.TELEFONO_CHOFER,
                CONFIRMADA: item.BITACORA_CONFIRMADA,
                UNIDAD: item.UNIDAD,
                CAPACIDAD: item.CAPACIDAD,
                ASIENTOS_DISPONIBLES: item.OCUPACIÓN,
                coordenadas: coordenadas
            });
        }

        return (
            <div
                className={`item-row ${isSelected ? 'selected' : ''}`}
                onClick={() => { findCordsUnidad(item); }}
                style={itemStyle}
            >
                {/* Ícono de selección */}
                {isSelected ?
                    <div className="selection-indicator" onClick={() => toggleSelection(item)}>
                        <i className="pi pi-check-circle" style={{
                            color: "#007ad9",
                            fontSize: "1.2rem",
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "white",
                            borderRadius: "50%",


                        }}></i>


                    </div>
                    :
                    <div className="selection-indicator" onClick={() => toggleSelection(item)}>
                        <i className="pi pi-circle" style={{
                            color: "#007ad9",
                            fontSize: "1.2rem",
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "white",
                            borderRadius: "50%",

                        }}></i>


                    </div>
                }

                <div className="item-ruta">{item.SERVICIO}</div>
                <div className="item-unidad">Unidad: {item.UNIDAD}</div>
                <Tag
                    value={item.ESTATUS}
                    className="item-estatus"
                    style={{
                        backgroundColor: design.tagColor,
                        color: "#fff",
                        // Ajustar opacidad si está seleccionado para mejor contraste
                        opacity: isSelected ? 0.9 : 1
                    }}
                />
                {item.NOTAS && item.NOTAS.length > 0 && (

                    <div className="mensajes" onClick={(e) => handleMostrarNotas(item, e)}>
                        <img src={notaIcon} alt="Ver notas" />
                    </div>

                )}
            </div>
        );
    };


    return (
        <div className="tableroListaDeServicios">
            <div className="filtros">
                <InputText
                    placeholder="Buscar por texto..."
                    value={filtro}
                    onChange={(e) => setFiltro(e.target.value)}
                    className="w-full"
                />
                <MultiSelect
                    value={estatusSeleccionados}
                    options={todosLosEstatus}
                    optionLabel="name"
                    onChange={(e) => setEstatusSeleccionados(e.value)}
                    placeholder="Filtrar por estatus"
                    className="w-full"
                    display="chip"
                    maxSelectedLabels={0}
                />

                <div className="filtros">
                    <Tooltip title='Desmarcar todo'>
                        <Button label="" icon={'pi pi-minus-circle'} style={{ marginTop: "10px" }} onClick={() => { setListaRutasPanelIzquierdo([]); setSelectedItems([]) }}></Button>
                    </Tooltip>
                </div>
                <div className="filtros">
                    <Tooltip title='Marcar todo'>
                        <Button label="" icon={'pi pi-check-circle'} style={{ marginTop: "10px" }} onClick={() => { marcarTodo() }}></Button>
                    </Tooltip>
                </div>
            </div>

            {/* Lista principal con scroll personalizado */}
            <div
                style={{
                    height: "calc(100vh - 250px)",
                    overflow: "auto"
                }}
                className="custom-scrollbar"
            >
                {datosFiltrados.map((item, index) => (
                    <div key={item.BITACORA || index}>
                        {itemTemplate(item)}
                    </div>
                ))}
                {datosFiltrados.length === 0 && (
                    <div style={{
                        padding: "40px",
                        textAlign: "center",
                        color: "#999",
                        fontSize: "16px"
                    }}>
                        No hay servicios para mostrar
                    </div>
                )}
            </div>

            {/* Debug info simplificada */}
            {/* <div style={{ padding: "8px", fontSize: "11px", color: "#666", backgroundColor: "#f8f9fa", borderRadius: "4px" }}>
                {datosFiltrados.length} servicios | {selectedItems.length} seleccionados
            </div> */}

            <ModalVerNotas
                visible={showModalNotas}
                onHide={() => setShowModalNotas(false)}
                notas={notasSeleccionadas}
                servicio={servicioSeleccionado}
            />
        </div>
    )
}
export default ListaServiciosEnVivo